<!--
 * @Author: chenming
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description: 漏斗图
-->
<script>
import ChartBase from '../base.vue';
/******* echarts *********/
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  DatasetComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components';
import { FunnelChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { isEmpty } from 'lodash';
/******* chart tools *********/
echarts.use([
  TitleComponent,
  DatasetComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  FunnelChart,
  CanvasRenderer
]);
export default {
  name: 'LcChartFunnel',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__funnel']
    };
  },
  created() {
    // preset
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    processChartData(data) {
      const options = this.mapOptions;
      if (!isEmpty(options)) {
        data.forEach(item => {
          item['name'] = item[options?.dimension];
          item['value'] = item[options?.valueMap];
        });
      }

      this.chartData = data;
    }
  }
};
</script>
